import sharesReducer from './shares.reducer';

export { default as sharesActions } from './shares.actions';
export { types as sharesTypes } from './shares.actions';
export { default as sharesSelectors } from './shares.selectors';


export default sharesReducer;
